export const validateEmail = (email) => {
    try {
        return new RegExp(/^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/).test(email);
    } catch (error) {
        return false;
    }
}

export const validatePhoneNumber = (phone) => {
    try {
        return new RegExp(/^(?:(?:\+|0{0,2})91|[0])?[6789]\d{9}$/).test(phone);
    } catch (error) {
        return false;
    }
}